import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  clearDevices({ commit }) {
    commit(types.CLEAR_DEVICES)
  },
  async getBusinessLocation({ commit, dispatch }, sid) {
    const r = await startLoading(dispatch, 'getBusinessLocation', () =>
      http.get(`BusinessQuery/Location?key=${sid}`)
    )
    commit(types.SET_LOCATION, r.data)
  },
  async getDevices({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getDevices', () =>
      http.get(`Device/GetDevices?id=${id}`)
    )
    commit(types.SET_DEVICES, r.data)
  },
  async searchDevices({ commit, dispatch }, search) {
    const r = await startLoading(dispatch, 'searchDevices', () =>
      http.get(`Device/GetDevicesForListing`, { params: search })
    )
    commit(types.SET_DEVICES, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/location/actions.js